import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    padding: "8px 16px 0 16px",
    flexDirection: "column"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 22
  },
  headerTitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    lineHeight: "normal",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 14
    }
  },
  addNoteButton: {
    display: "flex",
    alignItems: "center",
    width: 82,
    height: 22,
    borderRadius: 2,
    border: "none",
    fontSize: 12,
    color: "#333333",
    padding: 0,
    textTransform: "capitalize",
    "& .MuiButton-label": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    "& .MuiButton-startIcon": {
      marginRight: 4,
      marginLeft: 0
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 14
    }
  },
  addNoteButtonActive: {
    display: "none"
  },
  addCircleIcon: {
    width: 12
  },
  noteForm: {
    marginTop: 12,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset, &.Mui-focused fieldset": {
        borderWidth: 1
      }
    }
  },
  noteTextarea: {
    "& .MuiInputBase-root": {
      padding: 12
    },
    "& textarea": {
      fontSize: 12
    }
  },
  noteTextareaButton: {
    fontSize: 12
  },
  noteTextareaCounter: {
    fontSize: 8,
    color: theme.palette.text.secondary,
    bottom: -8
  },
  notes: {
    display: "flex",
    flexDirection: "column",
    marginTop: 8
  },
  notesGroup: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 8
  },
  notesGroupHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    height: 20,
    color: "#2d2d2d",
    backgroundColor: "#eeeeee",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  note: {
    display: "flex",
    marginTop: 4,
    fontSize: 12
  },
  noteTime: {
    minWidth: 60,
    color: "#2d2d2d",
    marginRight: 4,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  noteBody: {
    wordBreak: "break-word",
    flex: "auto",
    fontSize: 12,
    color: theme.palette.text.primary,
    lineHeight: "normal"
  },
  noteAuthor: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  noteDeleteButton: {
    width: 12,
    height: 12,
    marginTop: -4,
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.warning.dark
    }
  },
  noteDeleteButtonIcon: {
    fontSize: 17
  },
  dialogPaper: {
    width: 290,
    height: 156
  },
  dialogTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 20,
    color: theme.palette.text.primary,
    padding: "12px 24px"
  },
  dialogContent: {
    fontSize: 14,
    color: "#333333",
    lineHeight: "20px",
    padding: "0 24px"
  },
  dialogActions: {
    padding: "8px 12px"
  },
  button: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  delete: {
    color: theme.palette.warning.dark
  }
}));
